/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GraduatoriaScorrimentoPianoRigaDTO { 
    riga_id?: string;
    posizione?: number;
    codice_pratica?: string;
    codice_fiscale?: string;
    nome?: string;
    cognome?: string;
    /**
     * Importo pieno riconosciuto alla riga
     */
    importo_base?: number;
    /**
     * Importo che la riga ha prima dello scorrimento (0 se non era finanziata)
     */
    importo_attuale?: number;
    /**
     * Importo che lo scorrimento aggiunge alla riga
     */
    importo_assegnato?: number;
    /**
     * Importo della riga dopo lo scorrimento
     */
    importo_finale?: number;
    /**
     * true se la riga non era finanziata e ora lo diventa (occupa un posto)
     */
    nuovo_beneficiario?: boolean;
}

